import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../common/image';
import useMain from '../../hooks/useMain';

const MarketMaker = () => {
	const { theme } = useMain();
	return (
		<div className='marketmaker py-5'>
			<div className='container'>
				<div className='row gy-4 align-items-center'>
					<div className='col-md-6 order-2 order-md-1'>
						<Image
							className='w-100'
							fileName='home/marketmaker.png'
						/>
					</div>
					<div className='col-md-6 order-1 order-md-2'>
						<h5 className={`text-uppercase text-set5-${theme}`}>What is</h5>
						<h1 className={`fw-bold text-set3-${theme}`}>
							<b>Market Maker</b>?
						</h1>
						<p>
							A <b>Market Maker</b>, also known as a <b>liquidity provider</b>, plays
							a fundamental role in the smooth operation of financial markets. This
							individual or legal entity continuously offers to buy and sell
							assets—such as cryptocurrencies, stocks, or foreign currencies—at
							publicly quoted prices. By doing so, the market maker ensures that there
							is always a counterparty available for trades. For example, when a
							retail trader decides to buy a certain asset, the market maker is there
							to sell it, and vice versa.
						</p>
						<p>
							Market makers are essential to maintaining <b>market liquidity</b>—the
							ease with which an asset can be bought or sold without causing drastic
							price changes. Their pricing is driven purely by the forces of{' '}
							<b>
								changes. Their pricing is driven purely by the forces of supply and
								demand changes. Their pricing is driven purely by the forces of{' '}
							</b>
							, and they actively participate in trades to reduce price volatility and
							ensure fair price discovery. By absorbing buy and sell orders, they
							minimize the spread between bid and ask prices, enabling efficient and
							fast transactions for all market participants.
						</p>
						<p>
							Whether in <b>traditional stock exchanges</b>,{' '}
							<b>foreign exchange markets</b>, or
							<b>decentralized blockchain protocols</b>, market makers serve as the
							backbone of trading infrastructure. At MMP WORLD, our advanced
							market-making strategies help ensure stability, continuous liquidity,
							and optimal trading conditions—allowing investors to trade with
							confidence in a reliable and responsive environment.
						</p>

						<Link
							to='/marketmaker'
							className={`btn btn-set3-${theme} me-3`}>
							Read More
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MarketMaker;
